import { render, staticRenderFns } from "./FAQMobile.vue?vue&type=template&id=2dce186a&scoped=true&"
import script from "./FAQMobile.vue?vue&type=script&lang=js&"
export * from "./FAQMobile.vue?vue&type=script&lang=js&"
import style0 from "./FAQMobile.vue?vue&type=style&index=0&id=2dce186a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dce186a",
  null
  
)

export default component.exports